import Help from "Components/Help";

const HelpPage = () => <Help />;

export default HelpPage;
